import React, { useState } from 'react';
import { elements, navigation, overlays } from '@ecosystem/newron-design-system';
import { triggerUpsellQualtrics, UpgradeType } from '../../analytics/upsell.qualtrics';
import { ContextManager } from '../../context/manager';
import { useCorePageState } from '../../page/provider';

function UpsellFooter({
  footerType,
  displayUpsellFooter,
}: {
  footerType: 'kpi' | 'feature';
  displayUpsellFooter: boolean;
}) {
  const { Icon } = elements;
  const { Toast } = overlays;
  const { Link } = navigation;
  const context = ContextManager.getInstance().get();
  const [toast, setToast] = useState<{ type: overlays.Notification; message: string }>();
  const corePageState = useCorePageState();
  const getUpsellFeatureFooter = () => {
    return (
      <div className="pl-2 text-sm">
        <Link
          onClick={() => {
            triggerUpsellQualtrics(context, setToast, corePageState, UpgradeType.FEATURE_UPGRADE);
          }}
        >
          Upgrade
        </Link>{' '}
        to unlock additional feature segments and product details.
        {getToast(toast)}
      </div>
    );
  };

  const getUpsellKpisFooter = () => {
    return (
      <div className="pl-2 text-sm">
        Gain access to more KPIs with a subscription{' '}
        <Link
          onClick={() => {
            triggerUpsellQualtrics(context, setToast, corePageState, UpgradeType.KPI_UPGRADE);
          }}
        >
          upgrade
        </Link>
        {getToast(toast)}
      </div>
    );
  };

  const getToast = toast => {
    return (
      toast && (
        <Toast type={toast.type} onComplete={() => setToast(undefined)}>
          {toast.message}
        </Toast>
      )
    );
  };
  const LockOpenOutlineIcon = Icon.icons['LockOpenOutline'];
  const upsellFeatureFooter = footerType === 'feature' ? getUpsellFeatureFooter() : null;
  return (
    displayUpsellFooter && (
      <div className="flex align-middle items-center ">
        <Icon color="default">
          <LockOpenOutlineIcon />
        </Icon>
        {footerType === 'kpi' ? getUpsellKpisFooter() : upsellFeatureFooter}
      </div>
    )
  );
}
export { UpsellFooter };
